// HelpVideoButton.jsx
import React from "react";
import { CustomButton } from "../components/CustomButton";
import { Text } from "../components/Text";

const HELP_VIDEO_CONFIG = {
  campaigns: {
    label: "How to send a campaign (Watch Video)",
    link: "https://youtube.com/playlist?list=PLqLA4UoWCEQsAGEajjvTqncc300bcJHzr&si=OIHp06uVofDwmfJX",
  },
  botflow: {
    label: "How to create a Botflow (Watch Video)",
    link: "https://youtube.com/playlist?list=PLqLA4UoWCEQvwJoSF-jso-5xc8-qWM5OV&si=q2C_FYVuPY9XXTmM",
  },
  template: {
    label: "How to create a template (Watch Video)",
    link: "https://youtube.com/playlist?list=PLqLA4UoWCEQuKyzKhujmcLcUivxwrYk95&si=PNuLGRS6t2nM9Pzo",
  },
  customers: {
    label: "How to add customer (Watch Video)",
    link: "https://youtu.be/cvHRMxilcVg?si=FFxmAfGtVTBBklv_",
  },
  salesSupport: {
    label: "How to manage customer chats (Watch Video)",
    link: "https://youtu.be/iPKW_mLei5k?si=cJwoADrWr4K9JDDG",
  },
};

const HelpVideoButton = ({ name }) => {
  const config = HELP_VIDEO_CONFIG[name];

  if (!config) return null;

  return (
    <div className="px-3 flex">
      <a
        href={config.link}
        target="_blank"
        rel="noopener noreferrer"
        style={{ textDecoration: "none" }}
      >
        <CustomButton
          varient="outline-white"
          type="button"
          label={
            <Text cust="flex align-items-center">
              <i
                className="pi pi-youtube mr-2"
                style={{ color: "#C6272D" }}
              />
              <span>{config.label}</span>
            </Text>
          }
        />
      </a>
    </div>
  );
};

export default HelpVideoButton;
